<div>
    <h1 class="title">
      Créez votre compte agence d'intérim
    </h1>

    <div class="fs-14 fw-6 mt-3">L'agence</div>

    <div class="row my-3">
      <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="nomAgence" [label]="
              'Nom de l\'agence'
            " [placeholder]="'ex: agence paris'" [type]="'text'" [required]="true"></app-custom-input>
    </div>

    <div class="row my-3">
      <div class="input-group">
        <app-custom-input
          [parentForm]="agenceInscriptionFormControl"
          controlName="siret"
          [label]="'SIRET'"
          [placeholder]="'ex: 98234817900010'"
          [type]="'text'"
          [required]="true">
        </app-custom-input>
        <button type="button" class="btn btn-primary" [disabled]="!siretFormField?.valid" (click)="validateSiret()">Valider</button>
      </div>

      <div class="fs-11 my-px-5" [ngClass]="{required: agenceInscriptionFormControl.get('siret')?.dirty,'text-secondary': !agenceInscriptionFormControl.get('siret')?.dirty}">
        <span *ngIf="agenceInscriptionFormControl.get('siret')?.hasError('pattern') && agenceInscriptionFormControl.get('siret')?.dirty" class="text-danger">
          Le SIRET doit contenir exactement 14 caractères numériques.
        </span>
        <span *ngIf="agenceInscriptionFormControl.get('siret')?.valid" class="text-success">
          Le SIRET est valide.
        </span>
      </div>

      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl"
         controlName="raisonSociale" [label]="'Raison sociale'"
         [placeholder]="'ex: SELARLU DOCTEUR BEN MEFTAH RIADH'" [type]="'text'"  [required]="true"></app-custom-input>
      </div>

      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="adresseSiege" [label]="
              'Adresse du siège social'
            " [placeholder]="'ex: C O CLINIQUE DE LYVETTE 67 ROUTE DE CORBEIL 91160 LONGJUMEAU'" [type]="'text'"
          [required]="true"></app-custom-input>
      </div>

      <div class="row my-3">
        <div class="col-md-7">
          <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="agencyEmail" [label]="
                'E-mail de l\'agence (facultatif)'
              " [placeholder]="'ex: contact@agence.com'" [type]="'email'"
              [errorMessage]="sameEmails ? 'Doit être différent de l\'e-mail de connexion du dirigeant.' : ''"></app-custom-input>
        </div>
        <div class="col-md-5">
          <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="agencyPhone" [label]="
                'Téléphone de l\'agence (facultatif)'
              " [placeholder]="'ex: 0123456789'" [type]="'text'"></app-custom-input>
        </div>
      </div>

      <div class="fs-14 fw-6 mt-4">Le dirigeant principal (administrateur de l'agence)</div>

      <div class="row my-3">
        <div class="col-md-3">
          <mat-label>Civilité</mat-label>
          <div class="dropdown position-relative">
            <mat-select [formControl]="$any(agenceInscriptionFormControl.get('dirigeantTitle'))" placeholder="—">
              @for (item of civilityOptions; track item) {
                <mat-option [value]="item.value">{{ item.label }}</mat-option>
              }
            </mat-select>
          </div>
        </div>
        <div class="col-md-4">
          <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="dirigeantPrenom"
            [label]="'Prénom'" [placeholder]="'ex: Jacques'" [type]="'text'" [required]="true"></app-custom-input>
        </div>
        <div class="col-md-5">
          <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="dirigeantNom"
            [label]="'Nom'" [placeholder]="'ex: Dupont'" [type]="'text'" [required]="true"></app-custom-input>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-md-6">
          <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="dirigeantFonction"
            [label]="'Fonction (facultatif)'" [placeholder]="'ex: Gérant'" [type]="'text'"></app-custom-input>
        </div>
        <div class="col-md-6">
          <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="dirigeantPhone"
            [label]="'Téléphone (facultatif)'" [placeholder]="'ex: 0612345678'" [type]="'text'"></app-custom-input>
        </div>
      </div>

      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="email" [label]="
            'E-mail de connexion du dirigeant'
          " [placeholder]="'ex: jacques.dupont@company.com'" [type]="'email'" [required]="true"></app-custom-input>
        <div class="fs-11 text-secondary">
          C'est votre identifiant : un code de vérification y sera envoyé à chaque connexion.
        </div>
      </div>

      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="password" [label]="
            'Votre mot de passe'
          " [type]="'password'" positionIcon="right" [required]="true"></app-custom-input>
        <div class="fs-11 my-px-5">
          @for (rule of passwordRules; track rule.label) {
            <span class="me-2" [ngClass]="{
                'text-success': rule.test(passwordFormField?.value),
                'text-secondary': !rule.test(passwordFormField?.value)
              }">{{ rule.test(passwordFormField?.value) ? '✓' : '•' }} {{ rule.label }}</span>
          }
        </div>
      </div>
    </div>
    <div class="row my-3">
      <app-button color="primary" (handleClick)="signupAgency()"
        [loading]="loading"
        [disabled]="agenceInscriptionFormControl.invalid || sameEmails || loading" text="Créer mon compte agence intérim"
        class="mx-auto text-center" [innerClass]="'p-3 w-100'"></app-button>
    </div>
</div>
